const initialState = {
  data: [],
  unread: 0,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER_NOTIFCATION":
      return {
        ...state,
        data: action.payload,
      };
    case "SET_UNREAD_NOTIFICATION":
      return {
        ...state,
        unread: action.payload,
      };

    default:
      return state;
  }
};

export default notificationReducer;
